import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksExportableBillConstructor,
  QuickBooksExportableBill,
} from './QuickBooksExportableBill'

export const QuickBooksExportableBillConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksExportableBillConstructor>({
    id: Factory.each(() => faker.random.number()),
    groupId: Factory.each(() => `BILL-${faker.random.number(9999)}`),
    vendorName: Factory.each(() => faker.company.companyName()),
    submittedDate: Factory.each(() => faker.date.past().toISOString()),
    dueDate: Factory.each(() => faker.date.future().toISOString()),
    uuid: Factory.each(() => faker.random.uuid()),
    stagedForExport: false,
  })

export const QuickBooksExportableBillFactory = EntityFactory(
  QuickBooksExportableBill,
  QuickBooksExportableBillConstructorFactory
)
